<template>
  <div class="container">
    <div class="index-section">
      <div class="cn-header">
        <img :src="cnLogo" alt="thecn.com" class="cn-logo" />
        <div>
          <template v-if="!isTypeNoOne">
            <router-link :to="'register'">
              Sign Up
            </router-link>
            <span class="mr-1 ml-1">|</span>
          </template>
          <router-link :to="'login'">
            Login to CN
          </router-link>
        </div>
      </div>
      <CoverImage />
      <div class="search-container">
        <h1>Find talent of {{ title }}</h1>
        <p v-if="count.institution_users >= 1000">
          {{ getMoreThanText(count.institution_users) }} ePortfolios created
        </p>
        <p v-else>Find talent of {{ title }} at one place.</p>
        <router-link class="search-input" :to="'search'">
          <font-awesome-icon icon="search" class="mr-3" />
          <div class="input">
            Search by name, skills, badges, or showcases
          </div>
        </router-link>
      </div>
    </div>
    <div class="ePortfolios-section" v-if="searchUsers.length">
      <h2>
        Member ePortfolios
      </h2>
      <UserInfoCardGroup :users="searchUsers" :nextOffset="nextOffset" />
    </div>
  </div>
</template>

<script>
import CoverImage from "@/components/users/cover-image.vue";
import UserInfoCardGroup from "@/components/users/user-info-card-group.vue";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  components: {
    UserInfoCardGroup,
    CoverImage,
  },
  data() {
    return {
      cnLogo: require("@/assets/img/cn_logo2.png"),
      nextOffset: 0,
    };
  },
  computed: {
    ...mapState("siteBrand", ["title", "count"]),
    ...mapState("siteBrandSearchUser", ["searchUsers"]),
    ...mapGetters("siteBrand", ["isTypeNoOne"]),
  },
  methods: {
    ...mapActions("siteBrandSearchUser", ["getSiteBrandSearchUser"]),
    getMoreThanText(count = 0) {
      if (count < 1000) {
        return count;
      } else {
        return "More than " + (count - (count % 1000));
      }
    },
  },
  created() {
    this.getSiteBrandSearchUser().then((data) => {
      this.nextOffset = data.extra_data.next_offset;
    });
  },
};
</script>

<style scoped lang="scss">
.index-section {
  .cn-header {
    margin: rem(54) 0 rem(54/2) 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    .cn-logo {
      height: rem(32);
    }
  }

  .search-container {
    padding: rem(25) 0 rem(40) 0;
    h1 {
      font-size: 32px;
      line-height: rem(44);
      font-style: normal;
      font-weight: 700;
      color: #1a374d;
      margin-bottom: rem(15);
    }
    p {
      font-size: rem(16);
      line-height: rem(22);
      font-weight: 400;
      color: #1a374d;
    }
    .search-input {
      display: flex;
      line-height: rem(60 * 0.33);
      align-items: center;
      padding: rem(25);
      width: 100%;
      height: rem(60 * 0.33);
      border: 1px solid #dddddd;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
      border-radius: rem(5);
      color: #1a374d;
      text-decoration: none;
      .input {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #555555;
      }
    }
  }
}
.ePortfolios-section {
  h2 {
    font-weight: 600;
    font-size: rem(20);
    line-height: rem(27);
    color: #12173f;
  }
}
</style>
